import dynamic from 'next/dynamic'

import { Button } from '@thg-commerce/gravity-elements'
import { spacing, styled } from '@thg-commerce/gravity-theme'

export const StoreStock = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/StoreStock'),
)

export const ArrowLeft = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ArrowLeft'),
)

export const ArrowRight = styled(ArrowLeft)`
  transform: rotate(180deg);
`

export const StoreStockButton = styled(Button)<{ hasBorderBottom?: boolean }>`
  width: 100%;
  border: 0;
  ${(props) => props.hasBorderBottom && `margin-bottom: ${spacing(2)};`}

  &:hover {
    border: 0;
  }

  &:has(button:disabled) {
    border-bottom: 1px solid transparent;
  }

  button {
    padding: ${spacing(1.5)} ${spacing(2)};
    text-transform: none;
    justify-content: start;
    border: solid 1px ${(props) => props.theme.colors.palette.greys.light};
    ${(props) =>
      !props.hasBorderBottom && 'border-bottom: 1px solid transparent;'}
    align-items: center;

    svg:first-child {
      margin-right: ${spacing(1)};
    }

    svg:last-child {
      margin-left: auto;
    }

    &:hover,
    &:focus,
    &:active,
    &:disabled {
      padding: ${spacing(1.5)} ${spacing(2)};
    }
  }
`
